/*
 * UX fix: adds a "Notify me when back in stock" email + phone capture under
 * any disabled/sold-out add-to-cart button. Submits to Shopify's built-in
 * contact form (no app required) so the merchant gets a message with the
 * product name, link, email, and (optionally) a phone number to text or
 * WhatsApp the shopper directly if they don't check email.
 */
(function () {
  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function injectNotifyForm(button) {
    if (!button || button.dataset.notifyInjected) return;

    var container = button.closest('.product-form__buttons') || button.parentElement;
    if (!container) return;

    button.dataset.notifyInjected = 'true';

    var productInfo = document.querySelector('[id^="ProductInfo-"]');
    var productUrl = (productInfo && productInfo.dataset.url) || window.location.pathname;
    var titleEl = document.querySelector('.product__title');
    var productTitle = (titleEl && titleEl.textContent.trim()) || document.title;

    var wrapper = document.createElement('div');
    wrapper.className = 'product-notify-me';
    wrapper.style.cssText = 'margin-top:1rem;width:100%;';
    wrapper.innerHTML =
      '<form action="/contact#ContactFooter" method="post" accept-charset="UTF-8" class="notify-me-form" style="display:flex;flex-wrap:wrap;gap:.5rem;align-items:flex-end;">' +
        '<input type="hidden" name="form_type" value="contact">' +
        '<input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="contact[subject]" value="Back in stock request: ' + escapeHtml(productTitle) + '">' +
        '<input type="hidden" name="contact[body]" value="Please notify me when &#39;' + escapeHtml(productTitle) + '&#39; (' + escapeHtml(window.location.origin + productUrl) + ') is back in stock.">' +
        '<label style="flex:1 1 100%;font-weight:600;font-size:.9em;">Notify me when back in stock</label>' +
        '<input type="email" name="contact[email]" placeholder="Your email address" required autocomplete="email" style="flex:1 1 200px;padding:.65em .8em;border:1px solid #ccc;border-radius:4px;font-size:.9em;">' +
        '<input type="tel" name="contact[Phone number]" placeholder="Phone (for SMS/WhatsApp updates)" autocomplete="tel" style="flex:1 1 200px;padding:.65em .8em;border:1px solid #ccc;border-radius:4px;font-size:.9em;">' +
        '<button type="submit" class="btn btn--secondary" style="padding:.65em 1.4em;white-space:nowrap;">Notify me</button>' +
        '<span style="flex:1 1 100%;font-size:.78em;opacity:.75;">Phone number is optional — add it if you\'d like a text or WhatsApp update instead of email.</span>' +
      '</form>';

    container.insertAdjacentElement('afterend', wrapper);
  }

  function scan() {
    document.querySelectorAll('.product-form__submit[disabled]').forEach(injectNotifyForm);
  }

  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('cart:updated', scan);
  document.addEventListener('variant:change', scan);
  // Catch late-hydrating variant pickers / theme-editor updates.
  setTimeout(scan, 800);
})();
